export default {
  "path": "/demo/text-copy-text-icon",
  "meta": {
    "name": "demo-复制文本图标",
    "title": "CopyTextIcon 复制文本图标",
    "isComponentDoc": true,
    "category": "Text"
  }
};